// Unico punto de lectura de import.meta.env. El resto del codigo consume AppConfig.
export const AppConfig = {
  app: {
    name: import.meta.env.VITE_APP_NAME || "Mis Vacaciones",
    version: __APP_VERSION__,
    environment: import.meta.env.VITE_APP_ENV || "development",
  },

  api: {
    useMock: import.meta.env.VITE_USE_MOCK === "true",
    cacheEnabled: import.meta.env.VITE_API_CACHE_ENABLED === "true",
    isLocal: import.meta.env.VITE_API_LOCAL === "true",
    localUrl: import.meta.env.VITE_API_LOCAL_URL || "https://localhost:7221/api",
    baseUrl: import.meta.env.VITE_API_BASE_URL || "https://mitrabajo.casadelaudio.com/api",
    timeout: Number.parseInt(import.meta.env.VITE_API_TIMEOUT) || 10000,
    retryAttempts: Number.parseInt(import.meta.env.VITE_API_RETRY_ATTEMPTS) || 3,
  },

  // Reglas de negocio del pedido de vacaciones (ver CLAUDE.md del repo)
  vacaciones: {
    anticipacionMinimaDias: 20,
    anticipacionMaximaDias: 300,
    maximoDiasCorridos: 35,
    // Unico tipo de cobro habilitado: Adelanto (TCobro.Adelanto = 1)
    cobroAdelanto: 1,
  },

  features: {
    debug: import.meta.env.VITE_ENABLE_DEBUG === "true",
  },

  isDevelopment: () => AppConfig.app.environment === "development",
  isProduction: () => AppConfig.app.environment === "production",
};
